import PageTemplate from '@/components/AppointmentTypesByPhaseList/components/PageTemplate';
import { useAllAppointmentTypeScheduleExpectationCycles } from '@/hooks/useAppointmentTypes/useAppointmentTypes';

import { Props } from './types';

const AllAppointmentTypeScheduleExpectationCycles = ({
  onSeeExpectationDetails,
  phase,
  timeZone
}: Props) => {
  const { id: phaseId } = phase;

  const { data, error, isError, isPending } =
    useAllAppointmentTypeScheduleExpectationCycles(phaseId);

  return (
    <PageTemplate
      data={data}
      error={error}
      isError={isError}
      isLoading={isPending}
      onSeeExpectationDetails={onSeeExpectationDetails}
      phase={phase}
      timeZone={timeZone}
      uiMode="muted"
    />
  );
};

export default AllAppointmentTypeScheduleExpectationCycles;
